import Vue from "vue";
import Router from "vue-router";
import Account from "./account";
import Cases from "./cases";
import Laws from "./laws";
import Notes from "./notes";
import Digests from "./digests";

Vue.use(Router);

export default new Router({
  scrollBehavior: function(to, from, savedPosition) {
      if (to.hash) {
          return {selector: to.hash}
          //Or for Vue 3:
          //return {el: to.hash}
      } else {
          return { x: 0, y: 0 }
      }
  },
  routes: [
    {
      path: "/dashboard",
      name: "home",
      component: () =>
      import(/* webpackChunkName: "organize" */ "@/views/Home.vue"),
      meta: {
        layout: "Split"
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: () =>
      import(/* webpackChunkName: "organize" */ "@/views/Settings.vue"),
      meta: {
        layout: "Split",
        showBack: true
      }
    },
    {
      path: "/legal",
      name: "legal",
      component: () =>
      import(/* webpackChunkName: "organize" */ "@/views/Legal.vue"),
      meta: {
        layout: "Split",
        showBack: true
      }
    },
    ...Account,
    ...Cases,
    ...Laws,
    ...Notes,
    ...Digests,
    {
      path: "/",
      redirect: '/dashboard',
    },
  ]
});
